import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from '@/lib/cn';

/**
 * Vertical stack layout component.
 */
const VStack = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(function VStack({
  className,
  ...props
}, ref) {
  return <div ref={ref} className={cn('flex flex-col', className)} {...props} />;
});
export default VStack;